export default {
    locale_code: "es-ES",
    sms: "SMS",
    rcs: "RCS",
    email: "Email",
    whatsapp: "WhatsApp",
    webhook: "Webhook",
    ia_basic: "IA Básico",
    ia_advanced: "IA Avançado",
    scheduled: "Programado",
    sent: "Enviado",
    accepted: "Aceptado",
    queued: "Procesando",
    failed: "Falló",
    text: "Texto",
    date: "Fecha",
    user: "Usuario",
    textarea: "Texto largo",
    number: "Número",
    coupon: "Cupón de descuento",
    checkbox: "Checkbox",
    currency_symbol: "$",
    percent_symbol: "%",
    active: "Activo",
    add: "Agregar", 
    archived: "Archivado",
    back: "Volver",
    brand: "Marca", 
    category: "Categoría",
    delete: "Eliminar",
    fields: "Campos",
    no_results_found: "No se encontraron resultados",
    options: "Opciones",
    paused: "Pausado",
    price: "Precio", 
    product: "Producto",
    quantity_short: "Cant",
    remove: "Eliminar",
    undo: "Deshacer",
    search: "Buscar",
    select: "Seleccionar",
    total: "Total",
    type: "Tipo",
    unavailable: "No disponible",
    value: "Valor",
    whatsapp_file_preview: "Vista previa del archivo de WhatsApp",
    username: "Nombre de usuario", 
    plugin: "Plugin",
    two_factor_auth: "Autenticación de dos factores",
    ces_score: "Puntuación CES",
    nps_score: "Puntuación NPS",
    valid_between: "Válido entre",
    days_ago: "Hace {0} días",
    today: "Hoy",
    tomorrow: "Mañana",
    in_x_days: "En {0} días",
    yes: "Sí",
    no: "No",
    outside_journey: "Fuera del Viaje",
    whatsapp_official: "WhatsApp Oficial",
    kevi_title_prefix: "Kevi",
    error: "Error",
    unknown: "Desconocido",
    tasks: "Tareas",
    "tasks-label": "Tareas",
    support: "Soporte",
    dates: {
        month: "mes",
        week: "semana",
        day: "día",
        year: "año",
        week_day: "día de la semana",
        hour: "hora",
        Mon: "Lun",
        Tue: "Mar",
        Wed: "Mié",
        Thu: "Jue",
        Fri: "Vie",
        Sat: "Sáb",
        Sun: "Dom",
        full_months: {
            "0": "enero",
            "1": "febrero",
            "2": "marzo",
            "3": "abril",
            "4": "mayo",
            "5": "junio",
            "6": "julio",
            "7": "agosto",
            "8": "septiembre",
            "9": "octubre",
            "10": "noviembre",
            "11": "diciembre",
        },
        full_weekdays: [
            "domingo",
            "lunes",
            "martes",
            "miércoles",
            "jueves",
            "viernes",
            "sábado",
        ],
        default_format: "[d] de [MM] de [Y]",
        format_day_month_long: "[d] de [MM]",
        format_full_date: "[d] de [MM] de [YY]",
        format_day_month_short: "[d]/[M]",
        format_day_month_short_time: "[d]/[M] a las [h]:[m]",
        format_date_2y: "[d]/[MM]/[Y]",
        format_date: "[d]/[M]/[Y]",
        format_date_time: "[d]/[M]/[Y] a las [h]:[m]",
        format_date_time_seconds: "[d]/[M]/[Y] a las [h]:[m]:[s]",
        format_date_time_weekday: "[d]/[M]/[Y] a las [h]:[m] - [D]:ucf",
        format_date_weekday: "[d]/[M]/[Y] ([D])",
        format_date_time_simple: "[d]/[M]/[Y] [h]:[m]",
        format_date_time_comma: "[d]/[M]/[Y], [h]:[m]",
        format_date_4y: "[d]/[M]/[YY]",
        format_weekday_date: "[D]:ucf - [d]/[M]/[Y]",
        format_weekday_date_time: "[D]:ucf - [d]/[M]/[Y] a las [h]:[m]",
        format_time: "[h]:[m]",
        format_month_year: "[MM]/[YY]",
        format_year: "[YY]",
        month_names: {
            "0": "Enero",
            "1": "Febrero",
            "2": "Marzo",
            "3": "Abril",
            "4": "Mayo",
            "5": "Junio",
            "6": "Julio",
            "7": "Agosto",
            "8": "Septiembre",
            "9": "Octubre",
            "10": "Noviembre",
            "11": "Diciembre"
        }
    },
    inputs: {
        datepicker: {
            month: "Mes",
            year: "Año",
            time: "Hora:",
            hour_placeholder: "HH",
            minute_placeholder: "MM",
            now: "Ahora",
            today: "Hoy",
            clear: "Limpiar",
            confirm: "Confirmar",
            weekdays: {
                sun: "Dom",
                mon: "Lun",
                tue: "Mar",
                wed: "Mié",
                thu: "Jue",
                fri: "Vie",
                sat: "Sáb",
            },
        },
    },
    rfm_groups: {
        cant_lose: "No se puede perder",
        champion: "Campeones",
        loyal: "Leales",
        needs_attention: "Necesitan atención",
        potential_champion: "Potenciales leales",
        new: "Nuevos",
        promising: "Prometedores",
        about_to_sleep: "A punto de dormir",
        at_risk: "En riesgo",
        hibernating: "Hibernando",
        lost: "Perdidos",
    },
    sender_options: {
        token: "Token",
        from: "De",
        from_name: "Nombre del remitente",
        from_email: "Email del remitente",
        from_phone: "Teléfono del remitente",
        whatsapp_business_id: "ID de WhatsApp Business",
        phone_number_id: "ID del número de teléfono",
        domain: "Dominio",
        account_token: "Token de cuenta",
        access_token: "Token de acceso",
        refresh_token: "Token de actualización",
        api_key: "Clave de API",
        channel_id: "ID del canal",
        client_id: "ID del cliente",
        secret_id: "Secreto del cliente",
        email: "Email",
        password: "Contraseña",
        slug: "Slug",
        id: "ID",
        instance_token: "Token de instância",
        instance_code: "Código de instância",
        instance_id: "ID da instância",
        subdomain: "Subdominio",
        api_access_token: "Token de acceso de la API",
        account_id: "ID de la cuenta",
        inbox_id: "ID de la bandeja de entrada",
        chatwoot_url: "URL de Chatwoot",
        meta_access_token: "Token de acceso Meta",
        base_url: "URL base",
    },
    filter_bar: {
        add_filter: "Agregar Filtro",
        select_filter: "Seleccione un filtro",
        clear_filter: "Limpiar filtro",
        period: "Período",
        branches: "Sucursales",
        client: "Cliente",
        form: "Formulario",
        avg_ticket: "Ticket promedio",
        orders_amount: "Número de pedidos",
        customer_profile: "Perfil del cliente",
        with_complete_registration: "Con registro completo",
        without_complete_registration: "Sin registro completo",
        points_balance: "Saldo de Puntos",
        client_segments: "Segmento del cliente",
        client_segments_not: "No está en segmento",
        last_order_period: "Período del último pedido",
        min_period_between_executions: "Tiempo mínimo entre ejecuciones",
        last_order_branch: "Sucursal del último pedido",
        clients_limit: "Límite de clientes",
        value: "Valor",
        automation_title: "Título de la automatización",
        type: "Tipo",
        campaigns: "Campañas",
        automations: "Automatizaciones",
        status: "Estado",
        active: "Activas",
        paused: "Pausadas",
        deleted: "Eliminadas",
        first_order_period: "Período del primer pedido",
        order_status: "Estado del Pedido",
        file_type: "Tipo de Archivo",
        file_preview: "Vista previa del archivo",
        whatsapp_file_preview: "Vista previa del archivo WhatsApp",
        image: "Imagen",
        pdf: "PDF",
        video: "Video",
        audio: "Audio",
        other: "Otro",
        purchased_in_period: "Comprou no período",
        registration_date: "Fecha de registro",
        name_phone_email_or_code: "Nombre, teléfono, email o código",
        coupon_code: "Código del cupom",
        expiration_date: "Fecha de vencimiento",
        usage_date: "Fecha de uso",
        automation: "Automação",
        situation: "Situação",
        available: "Disponible",
        used: "Utilizado",
        expired: "Vencido",
        accepted: "Aceptada",
        scheduled: "Programada",
        sent: "Enviada",
        failed: "Fallida",
        processing: "Procesando",
        method: "Método",
        quotation_status: "Estado del Presupuesto",
        responsible: "Responsable",
        task_deadline: "Plazo de la tarea",
        creation_date: "Fecha de creación",
        completion_date: "Fecha de conclusión",
        pending: "Pendientes",
        completed: "Completadas",
        archived: "Archivadas",
        quotations_amount: "Número de cotizaciones",
        quotations_value: "Valor de cotizaciones",
        rfm_group: "Grupo RFM",
        campaign_interactions: "Interações de Campanha",
        days_after: "Días después de ",
        custom_event: "Evento Personalizado",
        purchased_product: "Comprou produto",
        with_phone: "Con teléfono",
        with_email: "Con email",
        accumulated_spending_clv: "Gasto acumulado (CLV)",
        days_since_last_order: "Días desde o último pedido",
        days_since_first_order: "Días desde o primeiro pedido",
        predicted_days_until_next_order: "Días previstos hasta el próximo pedido",
        days_since_registration: "Días desde o registro",
        age: "Edad",
        month_birthday: "Cumpleañeros del mes",
        communication_channels: "Canais de Comunicação",
    },
    user_notifications: {
        edited_task: "{$0} editó la tarea {$1}",
        commented_on_task: "{$0} comentó en la tarefa {$1}",
        completed_task: "{$0} completou a tarefa {$1}",
        archived_task: "{$0} arquivou a tarefa {$1}",
        moved_task_to_column: "{$0} moveu a tarefa {$1} para a coluna {$2}",
        beta_admin_only: "Beta: Disponible solo para administradores",
        no_notifications: "Sin notificaciones",
        mark_all_read: "Marcar todas como leídas",
    },
    searchSelect: {
        placeholder: "Buscar...",
        client_placeholder: "Buscar cliente...",
        clear: "Limpiar",
        loading: "Buscando...",
        empty: "No se encontraron resultados",
        hint: "Escriba al menos {0} caracteres para buscar",
        close: "Cerrar",
    },
    confirm_phrase: {
        instruction: "Escriba la siguiente frase para confirmar la acción:",
        placeholder: "Escriba la frase de confirmação aqui",
    },
    info_modal: {
        close: "Cerrar",
    },
    kv_search_select: {
        loading: "Buscando...",
        empty: "Sin resultados",
        hint: "Escribe al menos {$0} caracter para buscar",
        close: "Cerrar",
        clear: "Limpiar",
        placeholder: "Buscar...",
    },
    clients_field: {
        placeholder: "Buscar cliente",
        aria_label: "Buscar cliente",
    },
    filter_group: {
        and_all: "Y (todos los filtros)",
        or_any: "O (cualquier filtro)",
        not_exclude: "NO (excluir)",
        add_filter: "Agregar filtro",
        add_group: "Agregar grupo",
        no_filters: "No hay filtros disponibles",
        empty_state: "Agregue filtros o grupos para crear su condición",
        remove_filter: "Eliminar filtro",
    },
    charts: {
        totals: "Totais",
    },
    code_editor: {
        placeholder: "Pegue su código aquí...",
        cancel: "Cancelar",
        save: "Guardar",
    },
    confirm: {
        cancel: "Cancelar",
        confirm: "Confirmar",
        close: "Cerrar",
    },
    editor: {
        bold: "Negrita",
        italic: "Cursiva", 
        underline: "Subrayado",
        strikethrough: "Tachado",
        heading1: "Título 1",
        heading2: "Título 2", 
        bullet_list: "Lista",
        numbered_list: "Lista numerada",
        undo: "Deshacer",
        redo: "Rehacer", 
        link: "Enlace",
        body_font: "(Fuente del cuerpo)",
        line_height: "Altura de línea",
    },
    custom_fields: {
        not_informed: "No informado",
        not_found: "No encontrado",
        select_user: "Seleccione el usuario",
    },
    custom_image: {
        change: "Cambiar",
        get_from_computer: "Obtener del ordenador",
        clean: "Limpiar",
    },
    datetime: {
        clear_date: "Limpiar fecha",
    },
    copy_button: {
        copy: "Copiar",
        copied: "¡Copiado!",
        copy_failed: "Error al copiar:",
    },
    grapejs: {
        blocks: {
            sect100: "1 Coluna",
            sect50: "2 Colunas",
            sect30: "3 Colunas",
            sect37: "2 Colunas",
            button: "Botón",
            divider: "Divisor",
            text: "Texto",
            "text-sect": "Seção de texto",
            image: "Imagen",
            quote: "Cita",
            grid_items: "Grid",
            list_items: "Lista",
            link: "Enlace",
            link_block: "Bloque de enlace",
        },
        save_email: "Guardar correo",
        save: "guardar",
        cancel: "cancelar",
        edit_menu: "Menú de edición",
        tokens: "Tokens:",
    },
    inputs: {
        keyvalue: {
            field: "Campo",
            value: "Valor",
            placeholder_key: "Ej: nome",
            placeholder_value: "Ej: nome",
            placeholder_value_template: "Ej: [[cliente.nombre]]",
            add_field: "Agregar campo",
        },
        datepicker: {
            month: "Mes",
            year: "Año",
            time: "Horário:",
            hour_placeholder: "HH",
            minute_placeholder: "MM",
            now: "Ahora",
            today: "Hoy",
            clear: "Limpiar",
            confirm: "Confirmar",
            weekdays: {
                sun: "Dom",
                mon: "Lun",
                tue: "Mar",
                wed: "Mié",
                thu: "Jue",
                fri: "Vie",
                sat: "Sáb",
            },
        },
        color: {
            title: "Color",
            open: "Abrir selector de color",
            hex: "#000000",
            basics: "Básicas",
            hue: "Matiz",
            saturation_brightness: "Saturación y brillo",
            saturation_brightness_value: "Saturación {0}%, brillo {1}%",
        },
        image: {
            title: "Subir imagen",
            description: "Arrastra y suelta o selecciona un archivo JPG o PNG.",
            button: "Seleccionar archivo",
            delete: "Eliminar imagen",
            defaultName: "Imagen",
            success: "Carga completada con éxito!",
            deleted: "Imagen eliminada con éxito!",
            deleteModalTitle: "Eliminar imagen",
            deleteModalDescription: "¿Estás seguro de que deseas eliminar esta imagen?",
            deleteModalCancel: "Cancelar",
            deleteModalConfirm: "Eliminar",
            statusCompleted: "Completado",
            statusUploading: "Subiendo...",
            statusError: "Error al subir",
            oversized: "El tamaño máximo por imagen es {0}MB. Las siguientes imágenes excedieron el límite: {1}",
            parseError: "Error al interpretar la respuesta del servidor.",
            serverError: "Ocurrió un error en el servidor al enviar las imágenes.",
            httpError: "Error {0} al realizar el upload.",
            networkError: "Error de red. Verifica tu conexión a internet.",
        },
        daterangepicker: {
            today: "Hoy",
            yesterday: "Ayer",
            this_month: "Este mes",
            this_year: "Este año",
            last_month: "Mes pasado",
            last_year: "Año pasado",
            all_period: "Todo el período",
            cancel: "Cancelar",
            apply: "Aplicar",
        },
        editor: {
            bold: "Negrita",
            italic: "Cursiva",
            underline: "Subrayado",
            strike: "Tachado",
            h1: "Título 1",
            h2: "Título 2",
            list: "Lista",
            ordered_list: "Lista numerada",
            undo: "Deshacer",
            redo: "Refacer",
            placeholder: "Escriba aquí...",
        },
        validation: {
            invalid_value: "Valor no válido",
            validation_error: "Error de validación",
        },
        select: {
            loading: "Carregando...",
            placeholder: "Seleccione...",
            search_placeholder: "Buscar...",
            empty_text: "No se encontraron opciones",
        },
    },
    reports: {
        filter_name: "Nombre del filtro",
        template_unavailable: "Plantilla no disponible",
        video_tag_not_supported: "Tu navegador no soporta la etiqueta de video.",
    },
    min: "Mín",
    max: "Máx",
    image: "Imagen",
    double_click_to_add_image: "Haga doble clic para agregar una imagen",
    visual_editor: {
        alignment: "Alineação",
        left: "Izquierda",
        center: "Centro",
        right: "Derecha",
        aspect_ratio: "Proporção",
        auto: "Auto",
        automatic: "Automático",
        drag_block: "Arrastar bloco",
        duplicate: "Duplicar",
        delete: "Eliminar",
        border: "Borda",
        solid: "Sólida",
        dashed: "Discontinua",
        dotted: "Punteada",
        spacing: "Espaçamento",
        top: "Superior",
        bottom: "Inferior",
        custom_settings: "Configurações personalizadas",
        display: "Visualización",
        block: "Bloque",
        inline: "En línea",
        drag_row: "Arrastar linha",
        drag_blocks_here: "Arrastre bloques aquí",
        no_settings: "No se encontraron configuraciones.",
        vertical: "Vertical",
        horizontal: "Horizontal",
        back_to_simple_mode: "Volver al modo simple",
        vertical_alignment: "Alineación vertical",
        middle: "Medio",
        width_unit: "Unidade de largura",
        percent: "Porcentaje",
        fixed_pixels: "Pixels fixos",
    },
    cancel: "Cancelar",
    apply: "Aplicar",
    save: "Guardar",
    edit: "Editar",
    actions: "Ações",
    status: "Estado",
    id: "Id",
    name: "Nombre",
    phone: "Teléfono",
    title: "Título",
    all: "Todos",
    loading: "Carregando...",
    yes: "Sí",
    no: "No",
    external_id: "Id externo",
    internal_server_error: "Error interno del servidor, intente nuevamente más tarde.",
    export: "Exportar",
    expiration_date: "Fecha de vencimiento",
    client: "Cliente",
    places: {
        details: {
            access_denied: "Acesso negado",
            view_as: "Ver como {name}",
            manage_plan: "Gestionar Plan",
            block: "Bloquear",
            activate: "Activar",
            automations_locked: "Automatizaciones {status}",
            place_blocked: "Establecimiento bloqueado",
            place_activated: "Establecimiento liberado",
            automations_on: "activadas",
            automations_off: "desactivadas",
            activate_automations: "Activar automatizaciones",
            deactivate_automations: "Desactivar automatizaciones",
        },
        branches: {
            title: "Sucursales",
            neighborhood_city: "Barrio / Ciudad",
            add_branch: "Agregar Sucursal",
        },
        modules: {
            title: "Módulos",
            updated: "¡Módulos actualizados!",
        },
        plugins: {
            title: "Plugins",
            add_plugin: "Agregar Plugin",
            choose_plugin: "Elegir Plugin",
            external_id: "Id Externo",
            created_at: "Criado em",
            settings_updated: "Configurações atualizadas",
        },
        roles: {
            title: "Cargos",
            new_role_placeholder: "Novo cargo",
            role_added: "Cargo añadido",
            role_updated: "Cargo actualizado",
            role_deleted: "Cargo Eliminado",
        },
        users: {
            title: "Usuarios",
            add_user: "Agregar Usuario",
            active: "Activo",
        },
    },
    quotations: {
        report_title: "Informe de Cotizaciones",
        budget_and_billing_by: "Presupuesto y Facturación por",
        group_by: "Agrupar por:",
        billing: "Facturación",
        budget: "Presupuesto",
        sent: "Cotizaciones Enviadas",
        clients: "Clientes",
        average_ticket: "Ticket Promedio",
        awaiting_approval: "Esperando Aprobación",
        approved: "Cotizaciones Aprovadas",
        rejected: "Cotizaciones Rechazadas",
    },
    inbox: {
        filters: {
            select_status: "Seleccione los estados",
            new: "Nuevo",
            pending: "Pendiente",
            solved: "Resuelto",
        },
    },
    segments: {
        filters: {
            birthdays_of_month: "Cumpleañeros del mes",
            period_label: "Período: hace {period} días.",
            limit_time_range: "Limitar intervalo de tempo",
            days_ago: "Días atrás",
            inform_values: "Informar valores",
            until: "Hasta",
            from: "A partir de",
            between: "Entre",
            and: "y",
            more_than: "Más de",
            select_values: "Seleccionar valores",
            indifferent: "Indiferente",
            accepted: "Aceptada",
            not_accepted: "No aceptada",
            event: "Evento",
            executions: "ejecuciones",
            which_event: "¿Qué evento?",
            search_event: "Buscar evento...",
            limit_by_values: "Limitar por valores",
            search_combined_info: "La búsqueda considera solo los campos informados, siempre combinados",
            which_product: "¿Qué producto?",
            which_category: "¿Qué categoría?",
            which_brand: "¿Qué marca?",
            purchase_quantity: "Quantidade de compras",
            purchases: "compras",
            which_status_to_execute: "¿En qué estado ejecutar?",
        },
    },
    settings: {
        journey: {
            title: "Jornada del cliente",
            stages: "Etapas",
            insert_first_stage: "Inserte la primera etapa",
            insert_first_substage: "Inserte la primera sub-etapa",
            board_renamed: "Tablero renombrado",
            board_prefix: "Tablero",
            add_stage_placeholder: "Agregar etapa...",
            order_saved: "Orden guardado",
            stage_renamed: "Etapa renombrada",
        },
        plugins: {
            title: "Disparadores",
            sender: "Disparador",
            monthly_value: "Valor mensal",
            cost_per_message: "Custo por mensagem",
            credits: "créditos",
            none_registered: "Ningún disparador registrado",
            edit_sender: "Editar disparador {name}",
            register_sender: "Registrar disparador",
            soon: "Próximamente",
            send_test_to: "Enviar prueba a:",
            save_changes: "Guardar cambios",
            add_sender: "Agregar Disparador",
            sender_saved_test_sent: "Disparador guardado, prueba enviada",
        },
        products: {
            title: "Productos",
            no_images: "Sem imagens",
            cost: "Costo",
            brand: "Marca",
            stock: "Estoque",
            external_id: "ID Externo",
            orders_12m: "Pedidos (12m)",
            revenue_12m: "Ingresos (12m)",
            current_price: "Precio actual",
            last_purchase: "Última compra",
            purchase_history: "Historial de Compras",
            bought_together: "Comprados Juntos",
            also_bought: "También Compraron",
            ai: "IA",
            manual: "Manual",
            last_10_orders_including_product: "Últimos 10 pedidos que incluyen este producto.",
            price_unit: "Precio Unit.",
            bought_in_same_order: "Produtos que foram comprados no mesmo pedido que este. Baseado nos últimos 90 dias de vendas.",
            clients_who_bought_also_bought: "Produtos que clientes que compraram este também compraram em outros pedidos. Baseado nos últimos 90 dias.",
            ai_recommendation_disclaimer: "Recomendação por IA: essas opções não são salvas no produto. Em vez disso, cada automação decide quando e como fazer o “match” por IA.",
            ai_placeholder: "Quien compró X también le puede gustar...",
            use_ai: "Usar IA",
            manual_recommendation_disclaimer: "Agregue productos relacionados rápidamente. Luego, si desea, puede incluir una recomendación (motivo) para cada vínculo.",
            search_product_to_link: "Buscar producto para vincular...",
            added_products: "Produtos agregados",
            no_manual_links: "Ningún producto manual vinculado ainda.",
            add_recommendation_optional: "Agregar recomendación (opcional)",
            link_removed: "Vínculo eliminado",
            product_linked: "Producto vinculado",
            recommendation_saved: "Recomendación guardada",
            product_not_found: "Producto no encontrado.",
            manage_groups: "Gestionar grupos",
            add_to_group: "Agregar al grupo",
            remove_from_group: "Eliminar del grupo",
            new_group: "Nuevo grupo",
            group_name: "Nombre del grupo",
            batch_edit: "Editar en lote",
            repurchase_days: "Días para recompra",
            group: "Agrupar",
            groups: "Grupos",
            products_updated: "Produtos atualizados",
            group_updated: "Grupo atualizado",
            something_went_wrong: "Ops, algo saiu mal",
        },
        translations: {
            title: "Traducciones",
            description: "Edite traduções por categoria e idioma. Los cambios se guardan al salir del campo.",
            locale: "Idioma",
            no_categories_found: "Ninguna categoría de traducción encontrada.",
            items_for: "ítem(s) para",
            no_translations_found: "Ninguna traducción encontrada en esta categoría.",
            key: "Clave",
            original_en: "Original (EN)",
            translated: "Traducido",
            saving: "Guardando...",
            saved: "Guardado",
            error_saving: "Error al guardar",
            unable_to_load: "No se pudieron cargar las traducciones",
            unable_to_load_items: "No se pudieron cargar los ítems de la categoría",
        },
    },
    smart_insertion: {
        title: "Inserções Inteligentes",
        register_space: "Registrar Espaço",
        name_id: "Nombre (id)",
        short_text: "Texto Corto",
        long_text: "Texto Largo",
        html: "HTML",
        add_field: "Agregar Campo",
        required: "Requerido",
    },
};
